import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Heading, Paragraph } from '@/components/common/MarkUp';
import { Surface } from '@/components/common/Surface';
import { Stack } from '@/components/layout/Stack';

import type { PullStat as PullStatType } from '@/sanity/sanity.types';

export interface PullStatProps extends PullStatType {}

export const PullStat = ({ keyStat }: PullStatProps) => {
  const { number, description } = keyStat;
  return (
    <StyledSurface padding={false}>
      <Stack spacing="--space-component-sm">
        <Metric size="heading-lg">{number}</Metric>
        {description && <Description size="body-lg">{description}</Description>}
      </Stack>
    </StyledSurface>
  );
};

const StyledSurface = styled(Surface)`
  padding-left: var(--space-component-xxl);
  margin-left: var(--space-block-md);
  border-left: 4px solid var(--decorative-galaxy);

  ${screen.lg} {
    margin-left: var(--space-block-lg);
  }
`;

const Metric = styled(Heading)`
  color: var(--text-galaxy);
`;

const Description = styled(Paragraph)``;
